import { FeatureSessionStore } from "./uidispatcherapi/FeatureSessionStore";
import Features from "./uidispatcherapi/Features";

// get A/B features;
// A/B Features are for features you need to dynamically toggle on and off (e.g. some migration or some temporary switching on/off)
// if you want to have different features in some countries than in other countries, use feature flags!
export const isCustomerSurveyEnabled = () => FeatureSessionStore.getMembershipFor(Features.OC_CUSTOMER_SURVEY) === "B";
export const isFsdDeliveryDateBeforeCheckoutEnabled = () =>
	FeatureSessionStore.getMembershipFor(Features.OC_FSD_DELIVERY_DATE_BEFORE_CHECKOUT) === "B";
